export enum CustomerRole {
	Staff = "Staff",
	Customer = "Customer",
}
